export default __webpack_public_path__ + "static/media/moneyIcon.ec12c83e.png";